import type { MarketIdentifiers } from '$lib/types/market';
import { Interface } from 'ethers/lib/utils.js';
import abi from '$lib/web3/abi';
import { MARKET_ADDRESES } from '$lib/web3/addresses';
import { SYNTHETIX_PERP_CONNECTOR } from './constants';
import type { IConnectorReturnData } from '../types';

export const addMargin = (
	marketIdentifier: MarketIdentifiers,
	marginDelta: string,
	getId: number = 0,
	setId: string = '0'
): IConnectorReturnData => {
	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	return {
		_target: SYNTHETIX_PERP_CONNECTOR,
		_callData: synthethixInterface.encodeFunctionData('addMargin', [
			MARKET_ADDRESES[marketIdentifier],
			marginDelta,
			getId,
			setId
		])
	};
};

export function removeMargin(marketIdentifier: MarketIdentifiers, marginDelta: string) {
	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	return {
		_target: SYNTHETIX_PERP_CONNECTOR,
		_callData: synthethixInterface.encodeFunctionData('removeMargin', [
			MARKET_ADDRESES[marketIdentifier],
			marginDelta,
			0,
			0
		])
	};
}
